import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import {
  Environment,
  ITicketsStatiGruppiPersone_TModel,
  ITicketsTipiStatiGruppi,
  TicketsStatiPerGruppo,
} from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class TicketsGruppiPersoneService extends CrudGenericsService<TicketsStatiPerGruppo, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/TicketsStatiGruppiPersone`);
    this.base = `${env.apiUrl}/api/TicketsStatiGruppiPersone/`;
  }
  // per la tabella
  GetList_TicketsStatiGruppiPersone(): Observable<ITicketsStatiGruppiPersone_TModel[]> {
    const u = this.base + 'GetList_TicketsStatiGruppiPersone';
    return this.http.get<ITicketsStatiGruppiPersone_TModel[]>(`${u}`);
  }

  FindTipo_Stato(idTipo: any, idStato: any) {
    const u = this.base + 'GetTickets_Tipo_Stato';
    let data = { idTipo: idTipo, idStato: idStato };
    return this.http.get<ITicketsTipiStatiGruppi>(`${u}`, { params: data });
  }
}
